export default [
    {
        path: "/2elbeVAJH5_3T0mR20Pev5zE",
        children: [
            {
                path: "ENmZsb_WpyVjB6VEKs0fgM_s",
                name: "view.account",
                meta: {
                    title: "Assets",
                    authRequired: true,
                    acc: ["y35031"],
                },
                component: () => import("../views/account/view.vue"),
            },
            {
                path: "PzHov8Ef0ThfceJAs6Ot4olE",
                name: "create.account",
                meta: {
                    title: "Assets",
                    authRequired: true,
                    acc: ["y35031"],
                },
                component: () => import("../views/account/create.vue"),
            },
            {
                path: "YnOJocWECdEYfdzMf8fQ",
                name: "list.account",
                meta: {
                    title: "Assets",
                    authRequired: true,
                    acc: ["y35031"],
                },
                component: () => import("../views/account/index.vue"),
            },
        ]
    },
]